import * as React from 'react';
import {Button} from '@/components/atoms/button.tsx';
import {Link} from '@tanstack/react-router';
export type AccountButtonProps = {
  isLoggedIn: boolean
}

export default function AccountButton(props: AccountButtonProps) {
  if(props.isLoggedIn) {
    return(
      <Button>
        <Link to="/account/home">
         My Account
        </Link>
      </Button>
    )
  }
  return(
    <Button>
      <Link to="/my-account">
        Sign In
      </Link>
    </Button>
  )
}
